import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import SecurityService from 'services/SecurityService';

/**
 * Renders the Login form in front of the top navbar.
 */
export default class Login extends React.Component {
    static propTypes = {
        username: PropTypes.string,
        userLoggedIn: PropTypes.bool,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            username: '',
            password: '',
            userLoggedIn: false
        };

        this.onLoginDropdownClick = this.onLoginDropdownClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
    }

    componentDidMount() {
        // listen for clicks outside our component so we can hide the login form
        window.PCM.appContainer.addEventListener('click', this.onDocumentClick);
    }

    componentDidUpdate() {
        if (this.state.open && this.state.username === '') {
            this.refs.usernameInputRef.focus();
        }
    }

    componentWillUnmount() {
        //remove our document listener
        window.PCM.appContainer.removeEventListener('click', this.onDocumentClick);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();//have to preventDefault first, otherwise if any errors occur instead of seeing them the app just reloads (nav's to home again)
        SecurityService.login(this.state.username, this.state.password);
        this.setState({
            password: '' // wipe out the password once the user is logged in
        });
    }

    onLoginDropdownClick(e) {
        const newState = !this.state.open;
        this.setState({
            open: newState
        });
    }

    onDocumentClick(e) {
        const area = ReactDOM.findDOMNode(this);

        if (!area.contains(e.target) && this.state.open) {
            this.setState({
                open: false
            });
        }
    }

    /**
     * We can't use bootstrap react components here because the bootstrap react dropdown menu was not intended to
     * include an embedded form, and it causes all sorts of problems with event handlers.
     * @returns {XML}
     */
    render() {
        let dropdownClass = 'login-container dropdown';

        if (this.props.userLoggedIn) {
            dropdownClass += ' hidden';
        } else if (this.state.open) {
            dropdownClass += ' open';
        }

        return (
            <div className={`${dropdownClass} `}>

                <span className="login-alert">You are not logged in.</span>
                <a
                    className="dropdown-toggle"
                    id="login-dropdown"
                    data-toggle="dropdown"
                    onClick={this.onLoginDropdownClick}
                >
                    <span><i className="fa fa-sign-in fa-lg" /> Login</span>
                </a>

                <ul className="dropdown-menu dropdown-menu-right">
                    <li>
                        <div className="formWrapper">
                            <form id="login-form" onSubmit={this.handleSubmit} >
                                <fieldset className="form-group">
                                    <label className="sr-only" htmlFor="username">username</label>
                                    <div className="input-group">
                                        <input value={this.state.username} onChange={this.handleInputChange} type="text" className="form-control" id="username" name="username" placeholder="username" ref="usernameInputRef"/>
                                        <div className="input-group-addon">
                                            <i className="fa fa-user fixedWidthFAIcon" />
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-group">
                                    <label className="sr-only" htmlFor="password">password</label>
                                    <div className="input-group">
                                        <input value={this.state.password} onChange={this.handleInputChange} type="password" className="form-control" id="password" name="password" placeholder="password" />
                                        <div className="input-group-addon">
                                            <i className="fa fa-key fixedWidthFAIcon" />
                                        </div>
                                    </div>
                                </fieldset>

                                <div id="loginErrors" className="small" />
                                <button type="submit" id="loginBtn" className="form-control btn btn-primary">Login</button>
                            </form>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/core/header/Login.js